
























































































import Vue from 'vue';
// import favorite from '@/modules/analysis/favorite';
import {
  Entry,
  Buyer,
  buyer as buyerM,
  BuyerCompany,
  buyerCompany as buyerCompanyM,
  Exhibition,
  exhibition as exhibitionM,
  entry as entryM,
  calender,
} from 'mostra';

type EntryInfo = {
  entry: Entry;
  buyer: Buyer;
  buyerCompany: BuyerCompany;
  exhibition: Exhibition;
};

export type DataType = {
  loading: boolean;
  entriesBase: Entry[]; // 全エントリーの最小限データ
  entries: EntryInfo[]; // 表示用の詳細データ
  currentPage: number;
  perPage: number;
  showAllEntries: boolean; // 全量表示フラグ
}

export default Vue.extend({
  name: 'admin-admin-analysis-vis-index',
  data(): DataType {
    return {
      loading: false,
      entriesBase: [],
      entries: [],
      currentPage: 1,
      perPage: 50,
      showAllEntries: false, // 初期は予約、もしくは入場中の来場者のみ
    };
  },
  computed: {
    totalPages(): number {
      return Math.ceil(this.filteredEntriesBase.length / this.perPage);
    },
    paginatedEntries(): EntryInfo[] {
      return this.entries;
    },
    filteredEntriesBase(): Entry[] {
      if (this.showAllEntries) {
        return this.entriesBase;
      }
      // 予約・入場以外のみフィルタリング
      return this.entriesBase.filter((entry) => entry.data.isReservation || entry.data.isEntry);
    },
  },
  methods: {
    formatDateTime(dt: any): string {
      return calender.formatDateTime(dt);
    },
    offline(entry: EntryInfo): string {
      const en = entry.entry;
      const exh = entry.exhibition;
      const off = exh.data.offlines.find((o) => o.id === en.data.exhibition.offlineId);
      return off ? off.venueName : '';
    },
    day(entry: EntryInfo): string {
      const en = entry.entry;
      const exh = entry.exhibition;
      const off = exh.data.offlines.find((o) => o.id === en.data.exhibition.offlineId);
      if (!off) {
        return '';
      }
      const day = off.days.find((d) => d.id === en.data.exhibition.dayId);
      return day ? calender.formatDate(day.date) : '';
    },
    async goToPage(page: number): Promise<void> {
      // ページトップへスクロール
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      await this.loadPageEntries();
    },
    async onToggleChange(): Promise<void> {
      // トグル変更時は1ページ目に戻す
      this.currentPage = 1;
      await this.loadPageEntries();
    },
    async loadPageEntries(): Promise<void> {
      this.loading = true;
      this.$loading(true);
      try {
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        const pageEntries = this.filteredEntriesBase.slice(start, end);
        const newEntries: EntryInfo[] = [];
        for (const en of pageEntries) {
          if (!en.id) continue;
          if (!en.data.buyer.uid || !en.data.exhibition.exhibitionId) {
            throw new Error('buyer id is not found');
          }
          const buyer = await buyerM.load(en.data.buyer.uid);
          if (!buyer || !buyer.data.cid) {
            throw new Error('buyer is not found');
          }
          const buyerCompany = await buyerCompanyM.load(buyer.data.cid);
          if (!buyerCompany) {
            throw new Error('buyerCompany is not found');
          }
          const exhibition = await exhibitionM.load(en.data.exhibition.exhibitionId);
          if (!exhibition) {
            throw new Error('exhibition is not found');
          }
          const entryInfo: EntryInfo = {
            entry: en,
            buyer,
            buyerCompany,
            exhibition,
          };
          newEntries.push(entryInfo);
        }
        this.entries = newEntries;
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.$loading(true);
    try {
      // 全エントリーの最小限データのみ取得
      const allEntries = await entryM.loads();
      // createdDtの降順でソート
      this.entriesBase = allEntries.sort((a, b) => {
        const dateA = a.data.createdDt;
        const dateB = b.data.createdDt;
        if (!dateA && !dateB) return 0;
        if (!dateA) return 1; // dateAがない場合は後ろに
        if (!dateB) return -1; // dateBがない場合は前に
        return dateB - dateA; // 降順（新しい順）
      });
      // 1ページ目の詳細データのみ取得
      await this.loadPageEntries();
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
});
